import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const channelsApi = createApi({
  reducerPath: 'channelsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CHANNELS_SERVICE_URL,
    prepareHeaders: (headers) => {
      const { getAccessToken } = require('../../../app/utils/authStorage');
      const token = getAccessToken();
      if (token) {
        headers.set('Content-Type', 'application/json');
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getMyChannels: builder.query({
      query: (botId) => ({
        url: '/v1/my',
        params: { bot_id: botId },
      }),
    }),
  }),
});

export const { useGetMyChannelsQuery } = channelsApi;
